import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';
import { useAuthStore } from '@/stores/auth';

const TEST_LEAD_TARGET = 66;

type TestLeadCount = {
  count: number;
  target: number;
  progress: number;
};

export function useTestLeadCount(): TestLeadCount | null {
  const user = useAuthStore((s) => s.user);
  const isTest = user?.account_status === 'test';
  const startedAt = user?.test_started_at;

  const { data } = useQuery({
    queryKey: ['test-lead-count', user?.id, startedAt],
    queryFn: async (): Promise<number> => {
      const result = await pb.collection('leads').getList(1, 1, {
        filter: `collector = "${user!.id}" && is_void != true && created >= "${startedAt}"`,
      });
      return result.totalItems;
    },
    enabled: isTest && !!startedAt && !!user?.id,
    refetchInterval: 30_000,
  });

  if (!isTest || data === undefined) return null;
  const pct = Math.min((data / TEST_LEAD_TARGET) * 100, 100);
  return { count: data, target: TEST_LEAD_TARGET, progress: pct };
}
